import { render, staticRenderFns } from "./EnteringValues.vue?vue&type=template&id=645d0f64&lang=pug&"
import script from "./EnteringValues.vue?vue&type=script&lang=js&"
export * from "./EnteringValues.vue?vue&type=script&lang=js&"
import style0 from "./EnteringValues.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports